<template>
    <div class="modal-container-cont">
        <div class="modal-container">
            <div class="modal-title">
                <h2 v-text="title"></h2>
            </div>
            <div class="prod-cards">
                <div class="prod_item" v-for="(suggest, key) in suggestProds" :key="key" @click="suggestChoose(suggest)">
                    <div class="img_container">
                        <img v-if="suggest.productImages && suggest.productImages.small != null" :src="getImagesURL(suggest, 'productImages', 'small')" alt="">
                        <img v-else :src="noImageSrc">
                    </div>
                    <div class="name_container">
                        <div class="container">
                            <span class="name" v-text="getProductLanguage(suggest, 'productName')"></span>
                        </div>
                    </div>
                    <div class="price_container">
                        <div class="container">
                            <span class="from" v-if="exibApartir(suggest)">{{ getString('a_partir_de') }}</span>
                            <span class="price" v-text="getMinPrice(suggest)"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LocaleController from '@/assets/controllers/LocaleController'
import Util from '@/assets/libs/util'
import MinPriceController from '@/assets/controllers/MinPriceController'
import ClarityController from '@/assets/controllers/ClarityController'

export default {
    name: 'SuggestionsModal',
    components: {

    },
    data () {
        return {
            noImageSrc: null,
            junk: require('../../static/icons/junk-icon.png'),
            suggestProds: [],
            title: this.getTitle()
        }
    },
    props: [
        'suggestData',
        'suggestModalDepth'
    ],
    mounted () {
        this.noImageSrc = Util.getConfigImage('noImage') ? Util.getConfigImage('noImage') : this.junk

        if (this.suggestData.flavours.length > 0) {
            this.suggestProds = this.suggestData.flavours
        } else if (this.suggestData.sizes.length > 0) {
            this.suggestProds = this.suggestData.sizes
        } else if (this.suggestData.combos.length > 0) {
            this.suggestProds = this.suggestData.combos
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        getImagesURL: function (prod, prop, size) {
            return Util.getImagesUrl(prod, prop, size)
            // return Util.getLocalConfigs('urlIMGOdhenInterface')
        },
        exibApartir: function (suggest) {
            return Util.exibApartir() && Util.variablePrice(suggest)
        },
        getMinPrice: function (suggest) {
            return MinPriceController.getMinPrice(suggest)
        },
        suggestChoose: function (prod) {
            let typeSuggestion = this.suggestModalDepth === 0 ? 'sabor' : this.suggestModalDepth === 1 ? 'tamanho' : 'combo'
            ClarityController.event(`usuario_aceitou_sugestao_${typeSuggestion}`)
            ClarityController.setTag(`sugestao_${typeSuggestion}_aceita`, prod.productName)
            this.$emit('suggestChoose', prod)
        },
        getTitle: function () {
            let title = ''
            let modalLevel = this.suggestModalDepth

            if (modalLevel === 0) {
                title = this.getString('qual_sabor_deseja')
            } else if (modalLevel === 1) {
                title = this.getString('posso_fazer_sugestao_tamanho')
            } else {
                title = this.getString('posso_fazer_sugestao_combo')
            }

            return title
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");
    .modal-container-cont{
        .full;
        pointer-events: none;
        display: block;
        bottom: 0;
        z-index: 4;
    }
    .modal-container {
        pointer-events: auto;
        margin: auto 75px;
        background: @white;
        border-radius: 25px;
        z-index: 4;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
        transform: translate(0%, -50%);
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;

        .modal-title {
            background-color: @primary-color;
            height: 120px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 25px 25px 0px 0px;

            h2 {
                font-size: 40px;
                color: @white;
            }
        }

        .prod-cards {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-evenly;

            .prod_item {
                width: 230px;
                height: 310px;
                background-color: @white;
                text-align: center;
                margin: 20px;
                box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
                border-radius: 5px;
                display: grid;
                grid-template-rows: 150px 100px 60px;

                .container{
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    width: calc(100% - 30px);
                    padding: 0 15px;
                }

                .img_container {
                    img {
                        object-fit: contain;
                        width: 100%;
                        max-height: 130px;
                        height: auto;
                        margin: auto;
                        margin-top: 20px;
                        display: block;
                    }
                }

                .name_container {
                    position: relative;
                    .name {
                        font-family: @default-font;
                        font-size: 1.2rem;
                        display: block;
                        max-width: 100%;
                        // text-transform: uppercase;
                        text-align: center;
                        margin: auto;
                        padding: 0;
                    }
                }

                .price_container {
                    position: relative;
                    .from {
                        text-transform: uppercase;
                        font-size: 1rem;
                        color: @primary-dark;
                        padding-top: 15px;
                    }
                    .price {
                        font-family: @default-font;
                        font-size: 1.2rem;
                        color: var(--price-font-color);
                        margin: 0;
                    }
                }
            }
        }
    }

    @media (max-width: 698px) { // Gertec SK210
        .modal-container {
            margin: auto 40px;
            .modal-title {
                height: 50px;
                h2 {
                    font-size: 20px;
                }
            }
            .prod-cards {
                .prod_item {
                    width: 160px;
                    height: 150px;
                    margin: 15px 5px;
                    grid-template-rows: 80px 40px 30px;
                    &.slimMode {
                        box-shadow: unset;
                        grid-template-rows: 80px 40px 30px;
                    }
                    .img_container {
                        img {
                            max-height: 70px;
                            margin-top: 7px;
                        }
                    }
                    .name_container {
                        .name {
                            font-size: 12px;
                        }
                    }
                    .price_container {
                        margin-bottom: 5px;
                        .from {
                            font-size: 10px;
                            padding-top: 0;
                        }
                        .price {
                            font-size: 12px;
                        }
                    }
                }
            }
        }
    }

    @media (min-width: 699px) and (max-width: 1025px) { //@tablet
        .modal-container {
            .modal-title {
                height: 100px;
                h2 {
                    font-size: 30px;
                }
            }

            .prod-cards {
                .prod_item {
                    width: 175px;
                    height: 270px;
                    margin: 10px;
                    grid-template-rows: 130px 80px 60px;

                    .container{
                        width: calc(100% - 30px);
                        padding: 0 15px;
                    }
                    &.slimMode {
                        box-shadow: unset;
                        grid-template-rows: 130px 70px 50px;
                    }

                    .img_container {
                        img {
                            max-height: 110px;
                            margin-top: 10px;
                        }
                    }

                    .name_container {
                        .name {
                            font-size: 1.2rem;
                        }
                    }
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/SuggestionsModal.vue